var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35698 7.77364C6.05523 9.07539 3.94468 9.07539 2.64294 7.77364C1.34119 6.47189 1.34119 4.36134 2.64294 3.0596C3.94468 1.75785 6.05523 1.75785 7.35698 3.0596L7.65161 3.35422M7.65161 3.35422H5.88384M7.65161 3.35422V1.58646",
    stroke: "#616161",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rotate.81cd2ef02253bf4888c89e1c33b2620f.svg";